import { useQuery } from "@tanstack/react-query";
import { researchService } from "../services/research.service";

export const useChat = (chatId: string) => {
  return useQuery({
    queryKey: ["chat", chatId],
    queryFn: () => researchService.getChat(chatId),
    enabled: !!chatId, // Only run query if chatId is provided
  });
};
